import React from "react";
import { Row, Col } from "reactstrap";
import { motion, AnimatePresence } from "framer-motion";

import Card from "./card";
import Subtract from "../../../../assets/images/verboden/VS.png";
import { fadeDelayVariants } from "../../../../components/shared/utils/animations";

const VsPlayers = (props) => {
  const {
    buzzledWords_A,
    buzzledWords_B,
    skippedWords_B,
    skippedWords_A,
    guessedWords_A,
    guessedWords_B
  } = props;

  const TeamAData = [
    {
      title: "GUESSED",
      color: "lightGreen",
      players: guessedWords_A
      // [
      //   { name: "CLERGY" },
      //   { name: "SORCEROR" },
      //   { name: "ACUPUNCTURE" },
      //   { name: "CLERGY" },
      //   { name: "SORCEROR" },
      //   { name: "ACUPUNCTURE" },
      //   { name: "CLERGY" },
      //   { name: "SORCEROR" },
      // ],
    },
    {
      title: "BUZZED",
      color: "darkRed",
      players: buzzledWords_A
      //  [
      //   { name: "CLERGY" },
      //   { name: "SORCEROR" },
      //   { name: "ACUPUNCTURE" },
      // ],
    },
    {
      title: "SKIPPED",
      color: "orange",
      players: skippedWords_A
      //  [
      //   { name: "CLERGY" },
      //   { name: "SORCEROR" },
      //   { name: "ACUPUNCTURE" },
      //   { name: "CLERGY" },
      // ],
    }
  ];
  const TeamBData = [
    {
      title: "GUESSED",
      color: "lightGreen",
      players: guessedWords_B
      // [
      //   { name: "CLERGY" },
      //   { name: "SORCEROR" },
      //   { name: "ACUPUNCTURE" },
      //   { name: "CLERGY" },
      //   { name: "SORCEROR" },
      // ],
    },
    {
      title: "BUZZED",
      color: "darkRed",
      players: buzzledWords_B
      // [
      //   { name: "CLERGY" },
      //   { name: "SORCEROR" },
      //   { name: "ACUPUNCTURE" },
      //   { name: "CLERGY" },
      //   { name: "SORCEROR" },
      // ],
    },
    {
      title: "SKIPPED",
      color: "orange",
      players: skippedWords_B
      //  [
      //   { name: "CLERGY" },
      //   { name: "SORCEROR" },
      //   { name: "ACUPUNCTURE" },
      //   { name: "CLERGY" },
      //   { name: "SORCEROR" },
      // ],
    }
  ];

  return (
    <div className="position-relative">
      <Row>
        <Col>
          <AnimatePresence exitBeforeEnter>
            <motion.div
              key="vb_left_players"
              variants={fadeDelayVariants}
              initial="hidden"
              animate="visible"
              exit="exit"
              className="results-col-wrap right"
            >
              <div className="team-column">
                {TeamAData.map((data, index) => (
                  <Card key={index} {...data} />
                ))}
              </div>
            </motion.div>
          </AnimatePresence>
        </Col>
        <Col>
          <AnimatePresence exitBeforeEnter>
            <motion.div
              key="vb_right_players"
              variants={fadeDelayVariants}
              initial="hidden"
              animate="visible"
              exit="exit"
              className="results-col-wrap left"
            >
              <div className="team-column">
                {TeamBData.map((data, index) => (
                  <Card key={index} {...data} secondTeam={true} />
                ))}
              </div>
            </motion.div>
          </AnimatePresence>
        </Col>
      </Row>
      <div className="text-orange vs-image rs">
        <img src={Subtract} />
      </div>
    </div>
  );
};

export default VsPlayers;
